export const errorsReducer = (state = {}, action: any) => {
  if (action.type.includes("_FAIL")) {
    if (action.payload.error) {
      return action.payload.error;
    }
    return action.payload;
  }
  return state;
};
